module.exports = __webpack_public_path__ + "img/logo.05c8f2b2.png";